import { useI18n } from "vue-i18n";
import { emptyCounts, OTHER_ENTITY } from "../domain/groupTargetFieldsByEntity";
export function useRequestTranslator() {
    const { t, te } = useI18n();
    return { t: (key) => t(key), te: (key) => te(key) };
}
export function serviceLabel(i18n, serviceCode) {
    const key = `compliance.request.services.${serviceCode}`;
    return i18n.te(key) ? i18n.t(key) : serviceCode.toUpperCase();
}
function entityKey(serviceCode, entity) {
    return `compliance.request.entities.${serviceCode}.${entity}`;
}
export function foldUntranslatedEntities(i18n, serviceCode, groups) {
    const translated = [];
    let other;
    for (const group of groups) {
        if (group.entity !== OTHER_ENTITY && i18n.te(entityKey(serviceCode, group.entity))) {
            translated.push(group);
            continue;
        }
        other ?? (other = { entity: OTHER_ENTITY, counts: emptyCounts() });
        for (const bucket of Object.keys(group.counts)) {
            other.counts[bucket] += group.counts[bucket];
        }
    }
    return other ? [...translated, other] : translated;
}
export function entityLabel(i18n, serviceCode, entity) {
    return i18n.t(entity === OTHER_ENTITY ? "compliance.request.entities.other" : entityKey(serviceCode, entity));
}
export function vocabularyKey(prefix, value, vocabulary) {
    return vocabulary.includes(value) ? `${prefix}.${value}` : `${prefix}.unknown`;
}
const IMPACT_THEMES = { Pending: "neutral", Reported: "green", Failed: "red", TimedOut: "orange" };
const APPLY_THEMES = {
    NotRequested: "neutral",
    Pending: "indigo",
    Applied: "green",
    Failed: "red",
    TimedOut: "orange",
};
export function impactBadgeTheme(status) {
    return IMPACT_THEMES[status] ?? "neutral";
}
export function applyBadgeTheme(status) {
    return APPLY_THEMES[status] ?? "neutral";
}
